module.exports = __webpack_public_path__ + "static/img/3161_phase_function_Paper_PointsHejduk_Prediction.6dc999c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3161_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 4hPm
// module chunks = 0